import { updateStateData } from "../Store/actions";
import store from "../Store/store";

/**
 * Per-list reload counts. The listing table shows "Loading…" while a list's
 * count is above 0. This is separate from batchLoading (full-page spinner).
 *
 * Opening New Campaign/Clip/Loop must not bump these counts.
 */
export const LISTING_RELOAD = {
  campaigns: "campaigns",
  clips: "clips",
  loops: "loops",
  stores: "stores",
};

const currentCounts = () => {
  const listingReload = store.getState().userSelections.listingReload;
  return typeof listingReload === "object" && listingReload !== null ? listingReload : {};
};

/** Mark that this list is fetching (first load, page change, filter, or save). */
export const beginListingReload = (listKey) => {
  const listingReload = currentCounts();
  const nextCount = (listingReload[listKey] || 0) + 1;
  store.dispatch(
    updateStateData({
      listingReload: {
        ...listingReload,
        [listKey]: nextCount,
      },
    })
  );
};

/** Clear one in-flight fetch for this list. Count never goes below 0. */
export const endListingReload = (listKey) => {
  const listingReload = currentCounts();
  const nextCount = Math.max(0, (listingReload[listKey] || 0) - 1);
  store.dispatch(
    updateStateData({
      listingReload: {
        ...listingReload,
        [listKey]: nextCount,
      },
    })
  );
};

export const withListingReload = async (listKey, work) => {
  beginListingReload(listKey);
  try {
    return await work();
  } finally {
    endListingReload(listKey);
  }
};

export const isListingReloading = (slice, listKey) => {
  const count = slice?.listingReload?.[listKey];
  return typeof count === "number" && count > 0;
};

/** Table Loading… until the list exists, or while that list is refetching. */
export const listingTableIsLoading = (slice, listKey, listData) => {
  if (typeof listData === "undefined") {
    return true;
  }
  return isListingReloading(slice, listKey);
};
